import { CommandController } from "./../../commanding/CommandController";
import { TrackingCache } from "./../../tracking/TrackingCache";
import { BasicSoundController } from "./BasicSoundController";
import { PaymentHashRefresher } from "./PaymentHashRefresher";
import { EnvGlobalsHandler } from "../EnvGlobalsHandler";
import { IAwayFromKeyboardController } from "./afkController/IAwayFromKeyboardController";
import { ConnectionTrackingCommandVO } from "./clientCommands/tracking/vo/ConnectionTrackingCommandVO";
import { BasicCommandVO } from "./commands/BasicCommandVO";
import { BasicContextMenuController } from "./contextMenuController/BasicContextMenuController";
import { SmartfoxEvent } from "../event/SmartfoxEvent";
import { BasicModel } from "../model/BasicModel";
import { ConnectionTrackingUtil } from "../tracking/ConnectionTrackingUtil";
import { BasicLayoutManager } from "../view/BasicLayoutManager";
import { getLogger } from "@goodgamestudios/logger";
import { BASIC_CONTROLLER } from "../../../../index";
import { ClientFunnelTrackingController } from "../../tracking/clientFunnel/ClientFunnelTrackingController";
import { ClientFunnelGameStates } from "../../tracking/clientFunnel/ClientFunnelGameStates";

import EventDispatcher = createjs.EventDispatcher;

const logger = getLogger(BASIC_CONTROLLER);

/*
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */
export class BasicController extends EventDispatcher {
    public static VERSION: string = "$Id$";
    public static NAME: string = "BasicController";

    public static COMMAND_GET_DOORMAN_SERVER_INSTANCES: string = "COMMAND_GET_DOORMAN_SERVER_INSTANCES";
    public static SELECT_INITIAL_INSTANCEVO: string = "SELECT_INITIAL_INSTANCEVO";
    public static COMMAND_HANDLE_SERVER_ERROR: string = "COMMAND_HANDLE_SERVER_ERROR";
    public static COMMAND_INIT_LOGGER: string = "COMMAND_INIT_LOGGER";
    public static COMMAND_INIT_SERVERCOMMANDS: string = "COMMAND_INIT_SERVERCOMMANDS";
    public static COMMAND_EXTENSION_RESPONSE: string = "COMMAND_EXTENSION_RESPONSE";
    public static COMMAND_SOCIAL_LOGIN: string = "COMMAND_SOCIAL_LOGIN";
    public static COMMAND_LOGIN: string = "COMMAND_LOGIN";
    public static COMMAND_LOGOUT: string = "COMMAND_LOGOUT";
    public static COMMAND_CHECK_MAINTENANCE: string = "COMMAND_CHECK_MAINTENANCE";
    public static COMMAND_CONNECT_CLIENT: string = "COMMAND_CONNECT_CLIENT";
    public static COMMAND_CONNECTION_LOST: string = "COMMAND_CONNECTION_LOST";
    public static COMMAND_CONNECTION_FAILED: string = "COMMAND_CONNECTION_FAILED";
    public static COMMAND_CONNECTION_TIMEOUT: string = "COMMAND_CONNECTION_TIMEOUT";
    public static COMMAND_JOINED_ROOM: string = "COMMAND_JOINED_ROOM";
    public static COMMAND_VERSION_CHECK: string = "COMMAND_VERSION_CHECK";
    public static COMMAND_INITALIZE_CONTROLLER: string = "COMMAND_INITALIZE_CONTROLLER";
    public static COMMAND_REGISTER_USER: string = "COMMAND_REGISTER_USER";
    public static COMMAND_RECONNECT: string = "COMMAND_RECONNECT";
    public static COMMAND_OPEN_FORUM: string = "COMMAND_OPEN_FORUM";
    public static COMMAND_DESTROY_GAME: string = "DESTROY_GAME";
    public static COMMAND_PREPARE_RECONNECT: string = "COMMAND_PREPARE_RECONNECT";
    public static COMMAND_SHOW_REGISTER_DIALOG: string = "COMMAND_SHOW_REGISTER_DIALOG";
    public static COMMAND_SHOW_COMA_TEASER: string = "COMMAND_SHOW_COMA_TEASER";
    public static COMMAND_CONNECT_TO_INSTANCEVO: string = "COMMAND_SELECT_INSTANCEVO_COMMAND";
    // TODO: Remove COMMAND_INIT_COUNTRIES after country loading implementation
    public static COMMAND_INIT_COUNTRIES: string = "COMMAND_INIT_COUNTRIES";
    public static COMMAND_PARSE_AVAILABLE_COUNTRIES: string = "COMMAND_PARSE_AVAILABLE_COUNTRIES";
    public static COMMAND_LOGIN_JSON: string = "COMMAND_LOGIN_JSON";
    public static COMMAND_REGISTER_USER_JSON: string = "COMMAND_REGISTER_USER_JSON";
    public static COMMAND_INVITE_FRIEND: string = "COMMAND_INVITE_FRIEND";
    public static COMMAND_INVITE_FRIEND_JSON: string = "COMMAND_INVITE_FRIEND_JSON";
    public static COMMAND_CHANGE_COUNTRY: string = "COMMAND_CHANGE_COUNTRY_COMMAND";
    public static COMMAND_INIT_ABTEST: string = "COMMAND_INIT_ABTEST";
    public static COMMAND_INIT_SERVERLIST: string = "COMMAND_INIT_SERVERLIST";
    public static COMMAND_INIT_ZONE_CAPACITY: string = "COMMAND_INIT_ZONE_CAPACITY";
    public static COMMAND_ADD_EXTRA_CURRENCY: string = "COMMAND_ADD_EXTRA_CURRENCY";
    public static COMMAND_ON_CLICK_MORE_CURRENY: string = "COMMAND_ON_CLICK_MORE_CURRENY";

    public static COMMAND_RELOAD_NETWORK: string = "COMMAND_RELOAD_NETWORK";
    public static COMMAND_UPDATE_NETWORK: string = "COMMAND_UPDATE_NETWORK";
    public static COMMAND_FACEBOOK_INITIALIZE: string = "COMMAND_FACEBOOK_INITIALIZE";
    public static COMMAND_FACEBOOK_CONNECT_LOGIN: string = "COMMAND_FACEBOOK_CONNECT_LOGIN";
    public static COMMAND_TEST_CDN: string = "COMMAND_TEST_CDN";
    // TODO: Deprecated. Delete after parsing countries from network.xml
    public static COMMAND_REPLACE_AVAILABLE_COUNTRIES_BY_INSTANCE_COUNTRIES: string = "COMMAND_REPLACE_AVAILABLE_COUNTRIES_BY_INSTANCE_COUNTRIES";
    public static COMMAND_CHANGE_LANGUAGE: string = "COMMAND_CHANGE_LANGUAGE";
    public static COMMAND_SERVER_INFO: string = "COMMAND_SERVER_INFO";
    public static COMMAND_SHOW_INGAME_HELP: string = "COMMAND_SHOW_INGAME_HELP";
    public static COMMAND_REPORT_SURVEY: string = "COMMAND_REPORT_SURVEY";
    public static COMMAND_VERIFY_PLAYER_MAIL: string = "COMMAND_VERIFY_PLAYER_MAIL";
    public static COMMAND_LOST_PASSWORD: string = "COMMAND_LOST_PASSWORD";
    public static COMMAND_CHILD_PROTECTION_SHUTDOWN_ALERT: string = "COMMAND_CHILD_PROTECTION_SHUTDOWN_ALERT";
    public static COMMAND_IDENTITY_MANAGEMENT: string = "COMMAND_IDENTITY_MANAGEMENT";
    public static COMMAND_HANDLE_IDENTITY_MANAGEMENT_ERROR: string = "COMMAND_HANDLE_IDENTITY_MANAGEMENT_ERROR";

    // Splitrun TestCaseInfo
    public static COMMAND_TEST_CASE_INFO: string = "COMMAND_TEST_CASE_INFO";

    // AgeGate
    public static COMMAND_CHECK_AGE_GATE_ACTIVITY: string = "COMMAND_CHECK_AGE_GATE_ACTIVITY";
    public static COMMAND_VALIDATE_AGE: string = "COMMAND_VALIDATE_AGE";

    //tracking commands
    public static COMMAND_TRACK_LOGIN: string = "COMMAND_TRACK_LOGIN";
    public static COMMAND_TRACK_PROFILING: string = "COMMAND_TRACK_PROFILING";
    public static COMMAND_TRACK_REGISTRATION_DATA: string = "COMMAND_TRACK_REGISTRATION_DATA";
    public static COMMAND_TRACK_GOOGLE_PIXEL: string = "COMMAND_TRACK_GOOGLE_PIXEL";
    public static COMMAND_TRACK_WORLD_ASSIGNMENT: string = "COMMAND_TRACK_WORLD_ASSIGNMENT";
    public static COMMAND_TRACK_CONNECTION_TRACKING_EVENT: string = "COMMAND_TRACK_CONNECTION_TRACKING_EVENT";
    public static COMMAND_TRACK_GAME_PAYMENT_SHOP_CLICK_EVENT: string = "COMMAND_TRACK_GAME_PAYMENT_SHOP_CLICK_EVENT";
    public static COMMAND_TRACK_DESKTOP_DEVICE_INFORMATION_EVENT: string = "COMMAND_TRACK_DESKTOP_DEVICE_INFORMATION_EVENT";
    public static COMMAND_VERIFY_TRACKING: string = "COMMAND_VERIFY_TRACKING";
    public static COMMAND_TRACK_INVITATION: string = "COMMAND_TRACK_INVITATION";
    public static COMMAND_TRACK_FACEBOOK_CONNECTION: string = "COMMAND_TRACK_FACEBOOK_CONNECTION";
    public static COMMAND_TRACK_FACEBOOK_USERDATA: string = "COMMAND_TRACK_FACEBOOK_USERDATA";

    // private offer
    public static PRIVATE_OFFER_VISUAL_ISO_OBJECT: string = "PRIVATE_OFFER_VISUAL_ISO_OBJECT";
    public static PRIVATE_OFFER_VISUAL_ACCEPT_DIALOG: string = "PRIVATE_OFFER_VISUAL_ACCEPT_DIALOG";
    public static PRIVATE_OFFER_QUEST_DIALOG: string = "PRIVATE_OFFER_QUEST_DIALOG";
    public static PRIVATE_OFFER_FAILED_DIALOG: string = "PRIVATE_OFFER_FAILED_DIALOG";
    public static PRIVATE_OFFER_FINISH_DIALOG: string = "PRIVATE_OFFER_FINISH_DIALOG";
    public static PRIVATE_OFFER_INTERFACE_BUTTON: string = "PRIVATE_OFFER_INTERFACE_BUTTON";
    public static PRIVATE_OFFER_OFFER_DIALOG: string = "PRIVATE_OFFER_OFFER_DIALOG";

    public static REQUEST_SOCIAL_LOGIN_KEYS: string = "REQUEST_SOCIAL_LOGIN_KEYS";
    public static CHOOSE_LOGIN_METHOD: string = "CHOOSE_LOGIN_METHOD";

    // Invite Codes
    public static COMMAND_GENERATE_INVITE_CODE: string = "COMMAND_GENERATE_INVITE_CODE";
    public static COMMAND_SET_INVITE_CODE: string = "COMMAND_SET_INVITE_CODE";

    // GTM
    public static GTM_CALL_GGS_TRACK_EVENT: string = "GTM_CALL_GGS_TRACK_EVENT";

    // Pre-client by country branching
    public static COMMAND_RELOAD_PAGE_WITH_ZONE_ID: string = "COMMAND_RELOAD_PAGE_WITH_ZONE_ID";

    // SessionId for the payment shop, aka 'CashHash'
    public paymentHash: string;
    private static _basicController: BasicController;
    private _soundController: BasicSoundController;
    private paymentHashRefresher: PaymentHashRefresher = new PaymentHashRefresher();
    private _awayFromKeyboardController: IAwayFromKeyboardController;
    private waitForServerMessage: any[] = [];
    public static commandDict: Map<any, any> = new Map<any, any>();

    public /*final*/ get soundController(): BasicSoundController {
        return this._soundController;
    }

    public /*final*/ set soundController(value: BasicSoundController) {
        this._soundController = value;
    }

    public static getInstance(): BasicController {
        if (!BasicController._basicController) {
            BasicController._basicController = new BasicController();
        }
        return BasicController._basicController;
    }

    public onLogIn(): void {
        BasicModel.smartfoxClient.startGameServerErrorDelayTimer(BasicModel.smartfoxClient.onLoginResponseFailed);
    }

    public onLoggedIn(): void {
        this.paymentHashRefresher.resetAndStartRefreshing();

        logger.debug("onLoggedIn()-> env.isIdentityManagementActive: " + EnvGlobalsHandler.globals.isIdentityManagementActive);

        // After the login it must be possible for user to open a forum via context menu.
        BasicContextMenuController.instance.enableContextMenuItem(BasicContextMenuController.FORUM_LABEL);
    }

    public onLogOut(): void {
        logger.debug("onLogOut()");
        // Stop connection tracking
        ConnectionTrackingUtil.instance.dispose();

        // Stop music
        if (this.soundController) {
            this.soundController.stopMusic();
            this.soundController.stopAllLoopedSoundEffects();
        }

        // After the logout it must be NOT possible for user to open a forum via context menu.
        BasicContextMenuController.instance.disableContextMenuItem(BasicContextMenuController.FORUM_LABEL);

        this.paymentHashRefresher.stopRefreshing();
        this.disposeLicenseRefresher();
        ClientFunnelTrackingController.getInstance().dispose();

        // After logout we can't verify the tracking by the current user. Dispose the tracking verifier.
        TrackingCache.getInstance().trackingVerifier.dispose();
    }

    public onDestroyGame(): void {
        logger.debug("onDestroyGame()");

        if (this.soundController) {
            this.soundController.stopMusic();
            this.soundController.stopAllLoopedSoundEffects();
        }

        this.disposeLicenseRefresher();
        ClientFunnelTrackingController.getInstance().dispose();
        logger.warn("ClientFunnelPlayTimeController.dispose?")
    }

    private disposeLicenseRefresher(): void {
        if (BasicModel.identityManagement) {
            BasicModel.identityManagement.stopLicenseRefresher();
        }
    }


    public /*final*/ connectClient(ip: string, port: number): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.SERVER_CONNECT);
        BasicModel.smartfoxClient.roundTripResponseSignal.addOnce(this.bindFunction(this.handleSmartfoxClientOnRoundTripResponse));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectSuccess));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECT_FAILED, this.bindFunction(this.onConnectFailed));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECT_TIMEOUT, this.bindFunction(this.onConnectTimeout));
        BasicModel.smartfoxClient.executeConnection(ip, port);
    }

    private handleSmartfoxClientOnRoundTripResponse(roundTripTime: number, bluebox: number): void {
        CommandController.instance.executeCommand(
            BasicController.COMMAND_TRACK_CONNECTION_TRACKING_EVENT,
            new ConnectionTrackingCommandVO(
                0,
                roundTripTime.toString(),
                bluebox
            )
        );
    }

    public sendServerMessageVOAndWait(messageVO: BasicCommandVO, waitingMessage: string = ""): void {
        this.waitForServerMessage.push(messageVO.getCmdId());
        BasicModel.smartfoxClient.sendCommandVO(messageVO);
    }

    public waitForMessage(waitingMessage: string): void {
        this.waitForServerMessage.push(waitingMessage);
    }

    private onConnectTimeout(event: SmartfoxEvent): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.SERVER_CONNECT_ERROR);
        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECTION_TIMEOUT);
    }

    private onConnectFailed(event: SmartfoxEvent): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.SERVER_CONNECT_ERROR);
        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECTION_FAILED);
    }

    private onConnectSuccess(event: SmartfoxEvent): void {
        logger.debug("[BasicController]: getting signal -- onConnection Success");
        CommandController.instance.executeCommand( BasicController.COMMAND_TRACK_WORLD_ASSIGNMENT );
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.SERVER_CONNECT_SUCCESS);
        BasicModel.smartfoxClient.removeEventListener(SmartfoxEvent.CONNECT_SUCCESS, this.bindFunction(this.onConnectSuccess));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.JOINED_ROOM, this.bindFunction(this.onJoinedRoom));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.EXTENSION_RESPONSE, this.bindFunction(this.onExtensionResponse));
        BasicModel.smartfoxClient.addEventListener(SmartfoxEvent.CONNECTION_LOST, this.bindFunction(this.onConnectionLost));
    }

    private onConnectionLost(event: SmartfoxEvent): void {
        logger.debug("onConnectionLost()");

        BasicModel.sessionData.loggedIn = false;
        ClientFunnelTrackingController.getInstance().dispose();
        this.paymentHashRefresher.stopRefreshing();
        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECTION_LOST);
    }

    private onJoinedRoom(event: SmartfoxEvent): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_JOINED_ROOM, event);
    }

    private onExtensionResponse(event: SmartfoxEvent): void {
        // check, if laggy client emulation should be used
        if (EnvGlobalsHandler.globals.useLaggyClientEmulation) {
            // calculate random lag
            let randomLag: number = Number((EnvGlobalsHandler.globals.laggyClientMaxDelay - EnvGlobalsHandler.globals.laggyClientMinDelay) * Math.random() + EnvGlobalsHandler.globals.laggyClientMinDelay);
            // fire the event delayed
            setTimeout(function(): void {
                logger.info("delaying incoming event by: " + randomLag + "ms");
                CommandController.instance.executeCommand(BasicController.COMMAND_EXTENSION_RESPONSE, event);
            }, randomLag);
        } else {
            // fire right away
            CommandController.instance.executeCommand(BasicController.COMMAND_EXTENSION_RESPONSE, event);
        }
    }

    /**
     *     check if arrived command is in waitinglist
     *  give command to layoutcomponents
     *     create ne waitinglist
     */
    public /*final*/ serverMessageArrived(message: string): void {
        if (this.waitForServerMessage.indexOf(message) >= 0) {
            this.layoutManager.checkWaitingAnimState(message);
            let temp: any[] = new Array();

            for (let i: number = 0; i < this.waitForServerMessage.length; i++) {
                if (this.waitForServerMessage[i] != message) {
                    temp.push(this.waitForServerMessage[i]);
                }
            }
            this.waitForServerMessage = temp;
        }
    }

    /**
     * write SoundSettings into SharedObject
     */
    public /*final*/ saveSoundSettings(): void {
        BasicModel.localData.saveSoundSettings([this.soundController.isMusicMuted, 1, this.soundController.isEffectsMuted, 1]);
    }

    /**
     * Login with JSON
     * standard social parameter:
     *  PLN, KEY, connectTime, ping, referrer, networkID
     * standard www parameter:
     *  name, pw, lang, did, connectTime, ping, accountId
     */
    public /*final*/ loginJson(paramsObject: Object): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_LOGIN_JSON, paramsObject);
    }

    /**
     * register with JSON
     * standard parameter:
     *  mail, pw, referrer, lang, did, connectTime, ping, accountId,
     *  campainPId, campainCr, campainPl, campainKey, campainNW, campainLP, campainCId, campainTS
     */
    public /*final*/ registerJSON(email: string, password: string, paramObject: Object): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_REGISTER_USER_JSON, [email, password, paramObject]);
    }

    /**
     * Check if Player ist Guest or not, show RegisterDialog or goto to Paymentshop
     * standard parameter:
     *  param not needed
     */
    public /*final*/ onClickMoreMoney(param: any[]): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_ON_CLICK_MORE_CURRENY, param);
    }

    /**
     * show registerDialog
     */
    public /*final*/ onStartRegisterDialog(): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_SHOW_REGISTER_DIALOG);
    }

    /**
     * open Paymentshop
     */
    public /*final*/ addExtraGold(): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_ADD_EXTRA_CURRENCY, this.paymentHash);
    }

    /**
     * invite friend
     * parameter:
     *  myname, name, mail
     */
    public /*final*/ inviteFriend(params: any[]): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_INVITE_FRIEND, params);
    }

    /**
     * invite friend with JSON
     * parameter:
     *  myname, name, mail
     */
    public /*final*/ inviteFriendJSON(params: any[]): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_INVITE_FRIEND_JSON, params);
    }

    private get layoutManager(): BasicLayoutManager {
        return BasicLayoutManager.getInstance();
    }

    public /*final*/ sendServerMessageAndWait(message: string, params: any[], waitingMessage: string): void {
        this.waitForServerMessage.push(waitingMessage);
        BasicModel.smartfoxClient.sendMessage(message, params);
    }

    public /*final*/ sendCommandVOAndWait(commandVO: BasicCommandVO): void {
        this.waitForServerMessage.push(commandVO.getCmdId());
        BasicModel.smartfoxClient.sendCommandVO(commandVO);
    }

    public static get hasBeenInitialized(): boolean {
        return BasicController._basicController != null;
    }

    public set awayFromKeyboardController(controller: IAwayFromKeyboardController) {
        this._awayFromKeyboardController = controller;
    }

}

